var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3","data-name":"Path 3","d":"M788.38,1224l5,5,5-5","transform":"translate(-787.938 -1223.558)","fill":"none","stroke":"#000","strokeWidth":"1.25"}));
}

ChevronInline.defaultProps = {"width":"10.884","height":"6.326","viewBox":"0 0 10.884 6.326"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
